// src/components/customModal/CustomModal.jsx
import React from "react";
import { Modal, Button } from "react-bootstrap";
import styles from "./CustomModal.module.css";

const CustomModal = ({
  show,
  onHide,
  title,
  children,
  actions = [],           // [{ text, variant, size, onClick, disabled, Component, buttonProps }]
  size = "md",            // "sm" | "md" | "lg"
  backdrop = "static",    // boolean | "static"
  keyboard = false,
  centerDialog = true,
  dialogClassName = "",
}) => (
  <Modal
    show={show}
    onHide={onHide}
    size={size}
    backdrop={backdrop}
    keyboard={keyboard}
    dialogClassName={`${centerDialog ? 'modal-dialog-centered' : ''} ${styles.dialog} ${dialogClassName}`}
  >
    {title && (
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
    )}

    <Modal.Body>
      {children}
    </Modal.Body>

    {actions.length > 0 && (
      <Modal.Footer className={styles.footer}>
        {actions.map(
          (
            {
              text,
              variant = "primary",
              size: btnSize,
              onClick,
              disabled = false,
              Component,
              className,
              buttonProps = {},
            },
            idx
          ) => {
            const ActionButton = Component || Button;
            // Spread buttonProps along with the other props
            const props = Component
              ? { onClick, disabled, className, ...buttonProps }
              : { variant, size: btnSize, onClick, disabled, className, ...buttonProps };

            return (
              <ActionButton key={idx} {...props}>
                {text}
              </ActionButton>
            );
          }
        )}
      </Modal.Footer>
    )}
  </Modal>
);

export default CustomModal;
